import { useState } from 'react';
import { VerificationDialog } from '@routes/MyAccount/components/Dialog/RequestActionDialog';
import {
  useFetchMyQuotationUserLazyQuery,
  CapaQuotationUserVerificationType
} from '@generated/graphql';
import PaymentBubble from '../PaymentBubble';
import { PaymentBubbleCommonProps } from '../types';

export default function PurchaseOrderRequestBubble({
  chatMessage,
  history
}: PaymentBubbleCommonProps) {
  const [openVeirificationDialog, setOpenVeirificationDialog] = useState<
    boolean
  >(false);
  const [fetchMe] = useFetchMyQuotationUserLazyQuery({
    fetchPolicy: 'cache-first'
  });

  const onClickButton = async () => {
    const { data } = await fetchMe();
    const me = data?.fetchMyQuotationUser?.data;
    const isVerified =
      me?.verificationType === CapaQuotationUserVerificationType.Verified;

    if (!history) return;

    if (isVerified) {
      const { pathname } = history.location;
      history.push(`${pathname}?menu=create_purchaseorder&p=2`);
    } else {
      setOpenVeirificationDialog(true);
    }
  };

  return (
    <>
      <VerificationDialog
        open={openVeirificationDialog}
        onClose={() => setOpenVeirificationDialog(false)}
      />
      <PaymentBubble>
        <PaymentBubble.Title>
          파트너가 발주서 발행 요청을 보냈습니다
        </PaymentBubble.Title>
        <PaymentBubble.Content>
          파트너가 발주서 발행을 요청했습니다. 거래 조건을 협의했다면 견적
          내용을 토대로 발주서를 발행해주세요.
        </PaymentBubble.Content>
        <PaymentBubble.Button buttonAction={onClickButton}>
          <i className="request-gtm-makeOrder-btn">발주서 발행하기</i>
        </PaymentBubble.Button>
      </PaymentBubble>
    </>
  );
}
